// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1vlps","errorLogs":"EditorFooter_errorLogs__2faiV"};